import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { registerSubscription } from '@adornis/baseql/metadata/register.js';
import { AdornisFilter } from '@adornis/filter/AdornisFilter.js';
import { Slot } from '@ils/slots/db/slot.js';
import { Names } from '@ils/static/names.js';
import { subscribeAllSlotsWithReportedErrorsResolver } from '../../server/resolver/reportedErrorsDataviewLine.js';
import { ILSUser } from '../ils-user.js';

@Entity()
export class ReportedErrorDataviewLine extends AdornisEntity {
  static override _class = Names.ReportedErrorDataviewLine._class;

  static override resolveID(entity: any): string {
    return entity.slot._id;
  }

  @Field(type => Slot)
  slot!: Slot;
  @Field(type => ILSUser)
  user!: ILSUser;
}

export const subscribeAllSlotsWithReportedErrors = registerSubscription({
  operationName: 'subscribeAllSlotsWithReportedErrors',
  resolve: subscribeAllSlotsWithReportedErrorsResolver,
  type: () => [ReportedErrorDataviewLine],
  params: [
    { name: 'skip', type: () => Int },
    { name: 'limit', type: () => Int },
    { name: 'filter', type: () => AdornisFilter },
  ],
});
